import { APP_URLS } from 'constants/urls';
import { BreadCrumbsOptions } from './types';
import getDashboardHomeItem from './dashboardHomeItem';

export default function getSitesBreadcrumbMap({
  pathname,
  t,
  entity,
}: BreadCrumbsOptions) {
  const dashboardHomeItem = getDashboardHomeItem({ t });
  const sitesItem = {
    label: t('sites'),
    path: APP_URLS.dashboard.sites.index.getPathWithQuery(),
  };
  const viewSiteItem = {
    label: t('view-site'),
    path: APP_URLS.dashboard.sites.view.getDynamicPath({
      pathParts: {
        id: `${entity?.id}`,
      },
    }),
  };

  return [
    {
      condition: APP_URLS.dashboard.sites.index.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        {
          label: t('sites'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.sites.add.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        {
          label: t('sites'),
          path: APP_URLS.dashboard.sites.index.getPathWithQuery(),
        },
        {
          label: t('create-new-site'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.sites.edit.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.id}`,
        },
      }),
      data: [
        dashboardHomeItem,
        sitesItem,
        {
          label: entity?.name,
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.sites.view.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.id}`,
        },
      }),
      data: [
        dashboardHomeItem,
        sitesItem,
        {
          label: entity?.name,
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.sites.areas.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.id}`,
        },
      }),
      data: [
        dashboardHomeItem,
        sitesItem,
        viewSiteItem,
        {
          label: t('site-areas'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.sites.users.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.id}`,
        },
      }),
      data: [
        dashboardHomeItem,
        sitesItem,
        viewSiteItem,
        {
          label: t('team'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.sites.viewCodeOfConduct.isTheSameUrlAs(
        pathname,
        {
          pathParts: {
            id: `${entity?.id}`,
          },
        },
      ),
      data: [
        dashboardHomeItem,
        sitesItem,
        viewSiteItem,
        {
          label: t('view-code-of-conduct'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.sites.editCodeOfConduct.isTheSameUrlAs(
        pathname,
        {
          pathParts: {
            id: `${entity?.id}`,
          },
        },
      ),
      data: [
        dashboardHomeItem,
        sitesItem,
        viewSiteItem,
        {
          label: t('edit-code-of-conduct'),
        },
      ],
    },
  ];
}
